export default "__VITE_ASSET__BEhbkHxa__"